import meditations from './meditations'

const romanMatrix = [
  [1000, 'M'],
  [900, 'CM'],
  [500, 'D'],
  [400, 'CD'],
  [100, 'C'],
  [90, 'XC'],
  [50, 'L'],
  [40, 'XL'],
  [10, 'X'],
  [9, 'IX'],
  [5, 'V'],
  [4, 'IV'],
  [1, 'I']
];

// https://stackoverflow.com/a/37723879
const convertToRoman = (int) => {
  if (int === 0) {
    return '';
  }

  for (var i = 0; i < romanMatrix.length; i++) {
    if (int >= romanMatrix[i][0]) {
      return romanMatrix[i][1] + convertToRoman(int - romanMatrix[i][0]);
    }
  }
}

export const generateMeditation = () => {
  const randomInt = Math.floor(Math.random() * meditations?.length)
  const romanNumeral = convertToRoman(randomInt + 1)

  return {
    romanNumeral,
    meditation: meditations?.[randomInt]
  }
}